// Card List slider
const cardList = document.querySelectorAll('[data-slider="card-list-slider"]');

const cardListOptions = {
  watchOverflow: true,
  spaceBetween: 24,
  slidesPerView: 'auto',
  speed: 800,
};

cardList.forEach((el) => {
  new Swiper(el, cardListOptions);
});

const cardListRequests = new WeakSet();

document.addEventListener('click', (ev) => {
  const link = ev.target.closest('[data-component="mod-card-list"] .pagination a');

  if (!link || link.classList.contains('is-disabled') || !link.dataset.page) {
    return;
  }

  ev.preventDefault();

  const parent = link.closest('[data-component="mod-card-list"]');
  const { action } = parent.dataset;

  if (cardListRequests.has(parent)) {
    return;
  }

  cardListRequests.add(parent);

  getNonceForAction(action)
    .then((nonce) => axios.post(localData.apiURL, {
      action,
      postId: parent.dataset.postId,
      blockIndex: parent.dataset.blockIndex,
      pageNumber: link.dataset.page,
      nonce,
    }))
    .then(({ data }) => {
      const list = parent.querySelector('[data-card-list-items]');
      const footer = parent.querySelector('[data-card-list-footer]');
      const notFound = parent.querySelector('.card-list__not-found');

      if (list) {
        list.innerHTML = data.data.html_list;
        const swiper = list.closest('[data-slider="card-list-slider"]')?.swiper;
        swiper?.slideTo(0, 0);
        swiper?.update();
      }

      if (footer) {
        footer.innerHTML = data.data.html_pagination;
      }

      notFound?.classList.toggle('hide', list?.children.length > 0);
      parent.scrollIntoView();
    })
    .catch((err) => {
      console.error(err);
    })
    .finally(() => {
      cardListRequests.delete(parent);
    });
});
